import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { ConversationPart } from './types';

export type ConversationStyles = Partial<
  Record<ConversationPart, SystemStyleObject>
>;

const [ConversationStylesProvider, useConversationStyles] =
  createContext<ConversationStyles>({
    name: 'ConversationStylesContext',
    strict: true,
    errorMessage:
      'useConversationStyles: `context` is undefined. Seems you forgot to wrap all menu components within `<Conversation />`',
  });

export { ConversationStylesProvider, useConversationStyles };
